export default {
  setAccessToken(context, accessToken) {
    context.commit("saveToken", accessToken);
  },
  authLogOut(context) {
    context.commit("logout");
  },
};
